import { Learn } from '@/features'
import { globalState } from '@codeleap/store'

const store = globalState<Learn.T.LessonStore>({})

export function set(params: Partial<Learn.T.LessonStore>) {
  store.set(params)
}

export function get<K extends keyof Learn.T.LessonStore>(key?: K): Learn.T.LessonStore | Learn.T.LessonStore[K] {
  return key ? store.get()[key] : store.get()
}

export function use(): Learn.T.LessonStore
export function use<T>(selector: (state: Learn.T.LessonStore) => T): T
export function use<T>(selector?: (state: Learn.T.LessonStore) => T) {
  return store.use(selector as any)
}
